/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface IssuesService {
  /** @summary Get All */
  getAllIssuesGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetAllIssuesGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllIssuesGetSchema,
        options: {
          parameters: GetAllIssuesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllIssuesGetData, GetAllIssuesGetError>>
    ): Promise<RequestFnResponse<GetAllIssuesGetData, GetAllIssuesGetError>>;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllIssuesGetParameters> | void
    ): ServiceOperationQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.issuesService.getAllIssuesGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllIssuesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        | (DeepReadonly<GetAllIssuesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllIssuesGetData,
          GetAllIssuesGetError,
          TData,
          ServiceOperationQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllIssuesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.issuesService.getAllIssuesGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllIssuesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        | (DeepReadonly<GetAllIssuesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllIssuesGetData,
          GetAllIssuesGetError,
          TData,
          ServiceOperationQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllIssuesGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllIssuesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.issuesService.getAllIssuesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllIssuesGetParameters,
      TQueryFnData = GetAllIssuesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllIssuesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        | (DeepReadonly<GetAllIssuesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllIssuesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllIssuesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.issuesService.getAllIssuesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllIssuesGetParameters,
      TQueryFnData = GetAllIssuesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllIssuesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        | (DeepReadonly<GetAllIssuesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllIssuesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllIssuesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllIssuesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllIssuesGetTotal = qraft.issuesService.getAllIssuesGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllIssuesGetResults = qraft.issuesService.getAllIssuesGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllIssuesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllIssuesGetCombinedResults = qraft.issuesService.getAllIssuesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllIssuesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllIssuesGetSchema,
          GetAllIssuesGetParameters,
          GetAllIssuesGetData,
          GetAllIssuesGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllIssuesGetData, GetAllIssuesGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetAllIssuesGetData, GetAllIssuesGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.issuesService.getAllIssuesGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllIssuesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        | (DeepReadonly<GetAllIssuesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllIssuesGetData,
          GetAllIssuesGetError,
          TData,
          ServiceOperationQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllIssuesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.issuesService.getAllIssuesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAllIssuesGetParameters, TData = GetAllIssuesGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        | (DeepReadonly<GetAllIssuesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllIssuesGetData,
          GetAllIssuesGetError,
          OperationInfiniteData<TData, GetAllIssuesGetParameters>,
          ServiceOperationInfiniteQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllIssuesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllIssuesGetParameters>,
      OperationError<GetAllIssuesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllIssuesGetData = qraft.issuesService.getAllIssuesGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllIssuesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllIssuesGetCombinedData = qraft.issuesService.getAllIssuesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllIssuesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllIssuesGetSchema,
          GetAllIssuesGetParameters,
          GetAllIssuesGetData,
          GetAllIssuesGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAllIssuesGetData, GetAllIssuesGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetAllIssuesGetData, GetAllIssuesGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllIssuesGetSchema,
        GetAllIssuesGetData,
        GetAllIssuesGetParameters,
        GetAllIssuesGetError
      > | void
    ): Promise<GetAllIssuesGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllIssuesGetSchema,
        GetAllIssuesGetData,
        GetAllIssuesGetParameters,
        GetAllIssuesGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllIssuesGetSchema,
        GetAllIssuesGetData,
        GetAllIssuesGetParameters,
        GetAllIssuesGetError
      > | void
    ): Promise<GetAllIssuesGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllIssuesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllIssuesGetSchema,
        GetAllIssuesGetData,
        GetAllIssuesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllIssuesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllIssuesGetData, GetAllIssuesGetParameters>>;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllIssuesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllIssuesGetSchema,
        GetAllIssuesGetData,
        GetAllIssuesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllIssuesGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllIssuesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllIssuesGetSchema,
        GetAllIssuesGetData,
        GetAllIssuesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllIssuesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllIssuesGetData, GetAllIssuesGetParameters>>;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        | (DeepReadonly<GetAllIssuesGetParameters> | void)
    ): GetAllIssuesGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        | (DeepReadonly<GetAllIssuesGetParameters> | void)
    ): OperationInfiniteData<GetAllIssuesGetData, GetAllIssuesGetParameters> | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>,
            data: NoInfer<OperationInfiniteData<GetAllIssuesGetData, GetAllIssuesGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>,
            data: GetAllIssuesGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        | (DeepReadonly<GetAllIssuesGetParameters> | void)
    ): QueryState<GetAllIssuesGetData, GetAllIssuesGetError> | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllIssuesGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<GetAllIssuesGetData, GetAllIssuesGetParameters>, GetAllIssuesGetError>
      | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllIssuesGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>,
      updater: Updater<
        NoInfer<GetAllIssuesGetData> | undefined,
        NoInfer<DeepReadonly<GetAllIssuesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllIssuesGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllIssuesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetAllIssuesGetSchema, GetAllIssuesGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAllIssuesGetData, GetAllIssuesGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetAllIssuesGetData, GetAllIssuesGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllIssuesGetData, GetAllIssuesGetParameters> | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >,
      updater: Updater<NoInfer<GetAllIssuesGetData> | undefined, NoInfer<GetAllIssuesGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetAllIssuesGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllIssuesGetSchema,
        GetAllIssuesGetData,
        TInfinite,
        GetAllIssuesGetParameters,
        GetAllIssuesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllIssuesGetSchema,
            GetAllIssuesGetData,
            TInfinite,
            GetAllIssuesGetParameters,
            GetAllIssuesGetError
          >
    ): number;
    schema: GetAllIssuesGetSchema;
    types: {
      parameters: GetAllIssuesGetParameters;
      data: GetAllIssuesGetData;
      error: GetAllIssuesGetError;
    };
  };
  /** @summary Create */
  createIssuesPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateIssuesPostBody, CreateIssuesPostParameters, TMeta, TSignal>,
      client?: (
        schema: CreateIssuesPostSchema,
        options: ServiceOperationMutationFnOptions<CreateIssuesPostBody, CreateIssuesPostParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateIssuesPostData, CreateIssuesPostError>>
    ): Promise<RequestFnResponse<CreateIssuesPostData, CreateIssuesPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateIssuesPostParameters> | void
    ): ServiceOperationMutationKey<CreateIssuesPostSchema, CreateIssuesPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.createIssuesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.createIssuesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateIssuesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateIssuesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateIssuesPostSchema,
        CreateIssuesPostData,
        CreateIssuesPostParameters,
        TVariables,
        OperationError<CreateIssuesPostError>,
        TContext
      >
    ): UseMutationResult<CreateIssuesPostData, OperationError<CreateIssuesPostError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.createIssuesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.createIssuesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateIssuesPostBody, CreateIssuesPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateIssuesPostSchema,
        CreateIssuesPostData,
        CreateIssuesPostParameters,
        TVariables,
        OperationError<CreateIssuesPostError>,
        TContext
      >
    ): UseMutationResult<CreateIssuesPostData, OperationError<CreateIssuesPostError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createIssuesPostTotal = qraft.issuesService.createIssuesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createIssuesPostTotal = qraft.issuesService.createIssuesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateIssuesPostBody,
            CreateIssuesPostData,
            CreateIssuesPostParameters,
            OperationError<CreateIssuesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateIssuesPostSchema,
            CreateIssuesPostBody,
            CreateIssuesPostData,
            CreateIssuesPostParameters,
            OperationError<CreateIssuesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createIssuesPostPendingMutationVariables = qraft.issuesService.createIssuesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createIssuesPostMutationData = qraft.issuesService.createIssuesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateIssuesPostData,
        OperationError<CreateIssuesPostError>,
        MutationVariables<CreateIssuesPostBody, CreateIssuesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateIssuesPostBody,
            CreateIssuesPostData,
            CreateIssuesPostParameters,
            OperationError<CreateIssuesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateIssuesPostSchema,
            CreateIssuesPostBody,
            CreateIssuesPostData,
            CreateIssuesPostParameters,
            OperationError<CreateIssuesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateIssuesPostData,
          OperationError<CreateIssuesPostError>,
          MutationVariables<CreateIssuesPostBody, CreateIssuesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateIssuesPostBody,
            CreateIssuesPostData,
            CreateIssuesPostParameters,
            OperationError<CreateIssuesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateIssuesPostSchema,
            CreateIssuesPostBody,
            CreateIssuesPostData,
            CreateIssuesPostParameters,
            OperationError<CreateIssuesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.issuesService.createIssuesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.issuesService.createIssuesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateIssuesPostBody,
              CreateIssuesPostData,
              CreateIssuesPostParameters,
              OperationError<CreateIssuesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateIssuesPostSchema,
              CreateIssuesPostBody,
              CreateIssuesPostData,
              CreateIssuesPostParameters,
              OperationError<CreateIssuesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateIssuesPostData,
            CreateIssuesPostError,
            MutationVariables<CreateIssuesPostBody, CreateIssuesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateIssuesPostBody,
              CreateIssuesPostData,
              CreateIssuesPostParameters,
              OperationError<CreateIssuesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateIssuesPostSchema,
              CreateIssuesPostBody,
              CreateIssuesPostData,
              CreateIssuesPostParameters,
              OperationError<CreateIssuesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateIssuesPostData,
          CreateIssuesPostError,
          MutationVariables<CreateIssuesPostBody, CreateIssuesPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateIssuesPostSchema;
    types: {
      parameters: CreateIssuesPostParameters;
      data: CreateIssuesPostData;
      error: CreateIssuesPostError;
      body: CreateIssuesPostBody;
    };
  };
  /** @summary Update */
  updateIssuesIssueIdPut: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateIssuesIssueIdPutBody,
        UpdateIssuesIssueIdPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateIssuesIssueIdPutSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateIssuesIssueIdPutBody,
          UpdateIssuesIssueIdPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateIssuesIssueIdPutData, UpdateIssuesIssueIdPutError>>
    ): Promise<RequestFnResponse<UpdateIssuesIssueIdPutData, UpdateIssuesIssueIdPutError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateIssuesIssueIdPutParameters> | void
    ): ServiceOperationMutationKey<UpdateIssuesIssueIdPutSchema, UpdateIssuesIssueIdPutParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.updateIssuesIssueIdPut.useMutation({
     *     path: {
     *         issue_id: issueId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.updateIssuesIssueIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         issue_id: issueId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateIssuesIssueIdPutBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateIssuesIssueIdPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateIssuesIssueIdPutSchema,
        UpdateIssuesIssueIdPutData,
        UpdateIssuesIssueIdPutParameters,
        TVariables,
        OperationError<UpdateIssuesIssueIdPutError>,
        TContext
      >
    ): UseMutationResult<UpdateIssuesIssueIdPutData, OperationError<UpdateIssuesIssueIdPutError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.updateIssuesIssueIdPut.useMutation({
     *     path: {
     *         issue_id: issueId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.updateIssuesIssueIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         issue_id: issueId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateIssuesIssueIdPutBody, UpdateIssuesIssueIdPutParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateIssuesIssueIdPutSchema,
        UpdateIssuesIssueIdPutData,
        UpdateIssuesIssueIdPutParameters,
        TVariables,
        OperationError<UpdateIssuesIssueIdPutError>,
        TContext
      >
    ): UseMutationResult<UpdateIssuesIssueIdPutData, OperationError<UpdateIssuesIssueIdPutError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateIssuesIssueIdPutTotal = qraft.issuesService.updateIssuesIssueIdPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateIssuesIssueIdPutTotal = qraft.issuesService.updateIssuesIssueIdPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             issue_id: issueId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateIssuesIssueIdPutBody,
            UpdateIssuesIssueIdPutData,
            UpdateIssuesIssueIdPutParameters,
            OperationError<UpdateIssuesIssueIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateIssuesIssueIdPutSchema,
            UpdateIssuesIssueIdPutBody,
            UpdateIssuesIssueIdPutData,
            UpdateIssuesIssueIdPutParameters,
            OperationError<UpdateIssuesIssueIdPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateIssuesIssueIdPutPendingMutationVariables = qraft.issuesService.updateIssuesIssueIdPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateIssuesIssueIdPutMutationData = qraft.issuesService.updateIssuesIssueIdPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 issue_id: issueId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateIssuesIssueIdPutData,
        OperationError<UpdateIssuesIssueIdPutError>,
        MutationVariables<UpdateIssuesIssueIdPutBody, UpdateIssuesIssueIdPutParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateIssuesIssueIdPutBody,
            UpdateIssuesIssueIdPutData,
            UpdateIssuesIssueIdPutParameters,
            OperationError<UpdateIssuesIssueIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateIssuesIssueIdPutSchema,
            UpdateIssuesIssueIdPutBody,
            UpdateIssuesIssueIdPutData,
            UpdateIssuesIssueIdPutParameters,
            OperationError<UpdateIssuesIssueIdPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateIssuesIssueIdPutData,
          OperationError<UpdateIssuesIssueIdPutError>,
          MutationVariables<UpdateIssuesIssueIdPutBody, UpdateIssuesIssueIdPutParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateIssuesIssueIdPutBody,
            UpdateIssuesIssueIdPutData,
            UpdateIssuesIssueIdPutParameters,
            OperationError<UpdateIssuesIssueIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateIssuesIssueIdPutSchema,
            UpdateIssuesIssueIdPutBody,
            UpdateIssuesIssueIdPutData,
            UpdateIssuesIssueIdPutParameters,
            OperationError<UpdateIssuesIssueIdPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.issuesService.updateIssuesIssueIdPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             issue_id: issueId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.issuesService.updateIssuesIssueIdPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateIssuesIssueIdPutBody,
              UpdateIssuesIssueIdPutData,
              UpdateIssuesIssueIdPutParameters,
              OperationError<UpdateIssuesIssueIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateIssuesIssueIdPutSchema,
              UpdateIssuesIssueIdPutBody,
              UpdateIssuesIssueIdPutData,
              UpdateIssuesIssueIdPutParameters,
              OperationError<UpdateIssuesIssueIdPutError>,
              TContext
            >
      ):
        | Mutation<
            UpdateIssuesIssueIdPutData,
            UpdateIssuesIssueIdPutError,
            MutationVariables<UpdateIssuesIssueIdPutBody, UpdateIssuesIssueIdPutParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateIssuesIssueIdPutBody,
              UpdateIssuesIssueIdPutData,
              UpdateIssuesIssueIdPutParameters,
              OperationError<UpdateIssuesIssueIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateIssuesIssueIdPutSchema,
              UpdateIssuesIssueIdPutBody,
              UpdateIssuesIssueIdPutData,
              UpdateIssuesIssueIdPutParameters,
              OperationError<UpdateIssuesIssueIdPutError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateIssuesIssueIdPutData,
          UpdateIssuesIssueIdPutError,
          MutationVariables<UpdateIssuesIssueIdPutBody, UpdateIssuesIssueIdPutParameters>,
          TContext
        >
      >;
    };
    schema: UpdateIssuesIssueIdPutSchema;
    types: {
      parameters: UpdateIssuesIssueIdPutParameters;
      data: UpdateIssuesIssueIdPutData;
      error: UpdateIssuesIssueIdPutError;
      body: UpdateIssuesIssueIdPutBody;
    };
  };
  /** @summary Remove */
  removeIssuesIssueIdDelete: {
    /** @summary Remove */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        RemoveIssuesIssueIdDeleteBody,
        RemoveIssuesIssueIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: RemoveIssuesIssueIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          RemoveIssuesIssueIdDeleteBody,
          RemoveIssuesIssueIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<RemoveIssuesIssueIdDeleteData, RemoveIssuesIssueIdDeleteError>>
    ): Promise<RequestFnResponse<RemoveIssuesIssueIdDeleteData, RemoveIssuesIssueIdDeleteError>>;
    /** @summary Remove */
    getMutationKey(
      parameters: DeepReadonly<RemoveIssuesIssueIdDeleteParameters> | void
    ): ServiceOperationMutationKey<RemoveIssuesIssueIdDeleteSchema, RemoveIssuesIssueIdDeleteParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.removeIssuesIssueIdDelete.useMutation({
     *     path: {
     *         issue_id: issueId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.removeIssuesIssueIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         issue_id: issueId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends RemoveIssuesIssueIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<RemoveIssuesIssueIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        RemoveIssuesIssueIdDeleteSchema,
        RemoveIssuesIssueIdDeleteData,
        RemoveIssuesIssueIdDeleteParameters,
        TVariables,
        OperationError<RemoveIssuesIssueIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveIssuesIssueIdDeleteData,
      OperationError<RemoveIssuesIssueIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.removeIssuesIssueIdDelete.useMutation({
     *     path: {
     *         issue_id: issueId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.issuesService.removeIssuesIssueIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         issue_id: issueId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<RemoveIssuesIssueIdDeleteBody, RemoveIssuesIssueIdDeleteParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RemoveIssuesIssueIdDeleteSchema,
        RemoveIssuesIssueIdDeleteData,
        RemoveIssuesIssueIdDeleteParameters,
        TVariables,
        OperationError<RemoveIssuesIssueIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveIssuesIssueIdDeleteData,
      OperationError<RemoveIssuesIssueIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const removeIssuesIssueIdDeleteTotal = qraft.issuesService.removeIssuesIssueIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const removeIssuesIssueIdDeleteTotal = qraft.issuesService.removeIssuesIssueIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             issue_id: issueId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RemoveIssuesIssueIdDeleteBody,
            RemoveIssuesIssueIdDeleteData,
            RemoveIssuesIssueIdDeleteParameters,
            OperationError<RemoveIssuesIssueIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveIssuesIssueIdDeleteSchema,
            RemoveIssuesIssueIdDeleteBody,
            RemoveIssuesIssueIdDeleteData,
            RemoveIssuesIssueIdDeleteParameters,
            OperationError<RemoveIssuesIssueIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const removeIssuesIssueIdDeletePendingMutationVariables = qraft.issuesService.removeIssuesIssueIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const removeIssuesIssueIdDeleteMutationData = qraft.issuesService.removeIssuesIssueIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 issue_id: issueId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RemoveIssuesIssueIdDeleteData,
        OperationError<RemoveIssuesIssueIdDeleteError>,
        MutationVariables<RemoveIssuesIssueIdDeleteBody, RemoveIssuesIssueIdDeleteParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RemoveIssuesIssueIdDeleteBody,
            RemoveIssuesIssueIdDeleteData,
            RemoveIssuesIssueIdDeleteParameters,
            OperationError<RemoveIssuesIssueIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveIssuesIssueIdDeleteSchema,
            RemoveIssuesIssueIdDeleteBody,
            RemoveIssuesIssueIdDeleteData,
            RemoveIssuesIssueIdDeleteParameters,
            OperationError<RemoveIssuesIssueIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RemoveIssuesIssueIdDeleteData,
          OperationError<RemoveIssuesIssueIdDeleteError>,
          MutationVariables<RemoveIssuesIssueIdDeleteBody, RemoveIssuesIssueIdDeleteParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Remove */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RemoveIssuesIssueIdDeleteBody,
            RemoveIssuesIssueIdDeleteData,
            RemoveIssuesIssueIdDeleteParameters,
            OperationError<RemoveIssuesIssueIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveIssuesIssueIdDeleteSchema,
            RemoveIssuesIssueIdDeleteBody,
            RemoveIssuesIssueIdDeleteData,
            RemoveIssuesIssueIdDeleteParameters,
            OperationError<RemoveIssuesIssueIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.issuesService.removeIssuesIssueIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             issue_id: issueId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.issuesService.removeIssuesIssueIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RemoveIssuesIssueIdDeleteBody,
              RemoveIssuesIssueIdDeleteData,
              RemoveIssuesIssueIdDeleteParameters,
              OperationError<RemoveIssuesIssueIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveIssuesIssueIdDeleteSchema,
              RemoveIssuesIssueIdDeleteBody,
              RemoveIssuesIssueIdDeleteData,
              RemoveIssuesIssueIdDeleteParameters,
              OperationError<RemoveIssuesIssueIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            RemoveIssuesIssueIdDeleteData,
            RemoveIssuesIssueIdDeleteError,
            MutationVariables<RemoveIssuesIssueIdDeleteBody, RemoveIssuesIssueIdDeleteParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RemoveIssuesIssueIdDeleteBody,
              RemoveIssuesIssueIdDeleteData,
              RemoveIssuesIssueIdDeleteParameters,
              OperationError<RemoveIssuesIssueIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveIssuesIssueIdDeleteSchema,
              RemoveIssuesIssueIdDeleteBody,
              RemoveIssuesIssueIdDeleteData,
              RemoveIssuesIssueIdDeleteParameters,
              OperationError<RemoveIssuesIssueIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          RemoveIssuesIssueIdDeleteData,
          RemoveIssuesIssueIdDeleteError,
          MutationVariables<RemoveIssuesIssueIdDeleteBody, RemoveIssuesIssueIdDeleteParameters>,
          TContext
        >
      >;
    };
    schema: RemoveIssuesIssueIdDeleteSchema;
    types: {
      parameters: RemoveIssuesIssueIdDeleteParameters;
      data: RemoveIssuesIssueIdDeleteData;
      error: RemoveIssuesIssueIdDeleteError;
      body: RemoveIssuesIssueIdDeleteBody;
    };
  };
}
/** @summary Get All */
export const getAllIssuesGet = {
  schema: {
    method: 'get',
    url: '/issues',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllIssuesGetSchema;
  [QraftServiceOperationsToken]: IssuesService['getAllIssuesGet'];
};
/** @summary Create */
export const createIssuesPost = {
  schema: {
    method: 'post',
    url: '/issues',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateIssuesPostSchema;
  [QraftServiceOperationsToken]: IssuesService['createIssuesPost'];
};
/** @summary Update */
export const updateIssuesIssueIdPut = {
  schema: {
    method: 'put',
    url: '/issues/{issue_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateIssuesIssueIdPutSchema;
  [QraftServiceOperationsToken]: IssuesService['updateIssuesIssueIdPut'];
};
/** @summary Remove */
export const removeIssuesIssueIdDelete = {
  schema: {
    method: 'delete',
    url: '/issues/{issue_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: RemoveIssuesIssueIdDeleteSchema;
  [QraftServiceOperationsToken]: IssuesService['removeIssuesIssueIdDelete'];
};
export const issuesService = {
  getAllIssuesGet,
  createIssuesPost,
  updateIssuesIssueIdPut,
  removeIssuesIssueIdDelete,
} as const;
type GetAllIssuesGetSchema = {
  method: 'get';
  url: '/issues';
  security: ['HTTPBearer'];
};
type GetAllIssuesGetParameters = undefined;
type GetAllIssuesGetData = paths['/issues']['get']['responses']['200']['content']['application/json'];
type GetAllIssuesGetError = unknown;
type CreateIssuesPostSchema = {
  method: 'post';
  url: '/issues';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateIssuesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateIssuesPostData = paths['/issues']['post']['responses']['200']['content']['application/json'];
type CreateIssuesPostError = paths['/issues']['post']['responses']['422']['content']['application/json'];
type CreateIssuesPostBody = paths['/issues']['post']['requestBody']['content']['application/json'];
type UpdateIssuesIssueIdPutSchema = {
  method: 'put';
  url: '/issues/{issue_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateIssuesIssueIdPutParameters = paths['/issues/{issue_id}']['put']['parameters'];
type UpdateIssuesIssueIdPutData = paths['/issues/{issue_id}']['put']['responses']['200']['content']['application/json'];
type UpdateIssuesIssueIdPutError =
  paths['/issues/{issue_id}']['put']['responses']['422']['content']['application/json'];
type UpdateIssuesIssueIdPutBody = paths['/issues/{issue_id}']['put']['requestBody']['content']['application/json'];
type RemoveIssuesIssueIdDeleteSchema = {
  method: 'delete';
  url: '/issues/{issue_id}';
  security: ['HTTPBearer'];
};
type RemoveIssuesIssueIdDeleteParameters = paths['/issues/{issue_id}']['delete']['parameters'];
type RemoveIssuesIssueIdDeleteData =
  paths['/issues/{issue_id}']['delete']['responses']['200']['content']['application/json'];
type RemoveIssuesIssueIdDeleteError =
  paths['/issues/{issue_id}']['delete']['responses']['422']['content']['application/json'];
type RemoveIssuesIssueIdDeleteBody = undefined;
